export const AREA_IMAGE_LIST = {
  female_face: {
    image: '/build/images/female-min.svg',
    style: 'height: 48px; width: 48px',
  },
  female_body: {
    image: '/build/images/female-body-front-min.svg',
    style: 'height: 40px; width: 40px',
  },
  male_face: {
    image: '/build/images/male-min.svg',
    style: 'height: 48px; width: 48px',
  },
  male_body: {
    image: '/build/images/male-body-front-min.svg',
    style: 'height: 40px; width: 40px',
  },
  male_body_back: {
    image: '/build/images/male-body-back-min.svg',
    style: 'height: 40px; width: 40px',
  },
  female_body_back: {
    image: '/build/images/female-body-back-min.svg',
    style: 'height: 40px; width: 40px',
  },
};

export const COMMON_DATA = [
  {
    id: 'female_face',
    name: 'Female face',
    icon: '/build/images/female-min.svg',
    isShow: true,
    style: 'height: 48px; width: 48px',
    bodyParts: [
      {
        id: 'forehead',
        name: 'Forehead',
        location: 'left: 50%; top: 37.5%',
      },
      {
        id: 'brow',
        name: 'Brow',
        location: 'left: 28.5%; top: 42.5%',
      },
      {
        id: 'hair',
        name: 'Hair',
        location: 'left: 50%; top: 18.5%',
      },
      {
        id: 'ears',
        name: 'Ears',
        location: 'left: 2.5%; top: 54%',
      },
      {
        id: 'eyes',
        name: 'Eyes',
        location: 'left: 69.5%; top: 49.5%',
      },
      {
        id: 'midface',
        name: 'Mid face',
        location: 'left: 28.5%; top: 57.5%',
      },
      {
        id: 'nose',
        name: 'Nose',
        location: 'left: 50%; top: 60%',
      },
      {
        id: 'mandible',
        name: 'Mandible',
        location: 'left: 20%; top: 70%',
      },
      {
        id: 'chin',
        name: 'Chin',
        location: 'left: 50%; top: 79%',
      },
      {
        id: 'neck',
        name: 'Neck',
        location: 'left: 50%; top: 89%',
      },
      {
        id: 'lower_face',
        name: 'Lower face',
        location: 'left: 70%; top: 65%',
      },
      {
        id: 'lips',
        name: 'Lips',
        location: 'left: 50%; top: 70%',
      },
    ],
  },
  {
    id: 'female_body',
    name: 'Female body',
    isShow: true,
    icon: '/build/images/female-body-front-min.svg',
    style: 'height: 40px; width: 40px',
    bodyParts: [
      {
        id: 'waist',
        name: 'Waist',
        location: 'left: 32.5%; top: 40%',
      },
      {
        id: 'upper_abdomen',
        name: 'Upper abdomen',
        location: 'left: 50%; top: 35%',
      },
      {
        id: 'lower_abdomen',
        name: 'Lower abdomen',
        location: 'left: 50%; top: 45%',
      },
      {
        id: 'axilla',
        name: 'Axilla',
        location: 'left: 30%; top: 25%',
      },
      {
        id: 'arms',
        name: 'Arms',
        location: 'left: 77%; top: 36%',
      },
      {
        id: 'inner_thigh',
        name: 'Inner thigh',
        location: 'left: 50%; top: 60%',
      },
      {
        id: 'outer_thigh',
        name: 'Outer thigh',
        location: 'left: 28%; top: 55%',
      },
      {
        id: 'hands',
        name: 'Hands',
        location: 'left: 10%; top: 50%',
      },
      {
        id: 'knees',
        name: 'Knees',
        location: 'left: 40%; top: 72%',
      },
      {
        id: 'ankles_feet',
        name: 'Ankles feet',
        location: 'left: 50%; top: 92.5%',
      },
      {
        id: 'hips',
        name: 'Hips',
        location: 'left: 50%; top: 92.5%',
      },
      {
        id: 'breast',
        name: 'Breast',
        location: 'left: 61%; top: 28%',
      },
      {
        id: 'labia',
        name: 'Labia',
        location: 'left: 50%; top: 52%',
      },
    ],
  },
  {
    id: 'male_face',
    name: 'Male face',
    icon: '/build/images/male-min.svg',
    isShow: true,
    style: 'height: 48px; width: 48px',
    bodyParts: [
      {
        id: 'waist',
        name: 'waist',
        location: 'left: 50%; top: 37.5%',
      },
      {
        id: 'brow',
        name: 'Brow',
        location: 'left: 28.5%; top: 42.5%',
      },
      {
        id: 'hair',
        name: 'Hair',
        location: 'left: 50%; top: 12.5%',
      },
      {
        id: 'ears',
        name: 'Ears',
        location: 'left: 2.5%; top: 54%',
      },
      {
        id: 'eyes',
        name: 'Eyes',
        location: 'left: 69.5%; top: 49.5%',
      },
      {
        id: 'midface',
        name: 'Mid face',
        location: 'left: 28.5%; top: 57.5%',
      },
      {
        id: 'nose',
        name: 'Nose',
        location: 'left: 50%; top: 60%',
      },
      {
        id: 'mandible',
        name: 'Man dible',
        location: 'left: 16.5%; top: 70%',
      },
      {
        id: 'chin',
        name: 'Chin',
        location: 'left: 50%; top: 79%',
      },
      {
        id: 'neck',
        name: 'Neck',
        location: 'left: 50%; top: 89%',
      },
      {
        id: 'lower_face',
        name: 'Lower face',
        location: 'left: 70%; top: 65%',
      },
      {
        id: 'lips',
        name: 'Lips',
        location: 'left: 50%; top: 70%',
      },
    ],
  },
  {
    id: 'male_body',
    name: 'Male body',
    icon: '/build/images/male-body-front-min.svg',
    isShow: true,
    style: 'height: 40px; width: 40px',
    bodyParts: [
      {
        id: 'waist',
        name: 'Waist',
        location: 'left: 32.5%; top: 40%',
      },
      {
        id: 'upper_abdomen',
        name: 'Upper abdomen',
        location: 'left: 50%; top: 35%',
      },
      {
        id: 'lower_abdomen',
        name: 'Lower abdomen',
        location: 'left: 50%; top: 45%',
      },
      {
        id: 'axilla',
        name: 'Axilla',
        location: 'left: 30%; top: 25%',
      },
      {
        id: 'arms',
        name: 'Arms',
        location: 'left: 80%; top: 36%',
      },
      {
        id: 'inner_thigh',
        name: 'Inner thigh',
        location: 'left: 50%; top: 60%',
      },
      {
        id: 'outer_thigh',
        name: 'Outer thigh',
        location: 'left: 30%; top: 60%',
      },
      {
        id: 'hands',
        name: 'Hands',
        location: 'left: 10%; top: 52.5%',
      },
      {
        id: 'knees',
        name: 'Knees',
        location: 'left: 40%; top: 72%',
      },
      {
        id: 'ankles_feet',
        name: 'Ankles feet',
        location: 'left: 50%; top: 92.5%',
      },
      {
        id: 'hips',
        name: 'Hips',
        location: 'right: 15%; top: 55%',
      },
      {
        id: 'chest',
        name: 'Chest',
        location: 'left: 63.5%; top: 28%',
      },
      {
        id: 'genitalia',
        name: 'Genitalia',
        location: 'left: 50%; top: 52.5%',
      },
    ],
  },
  {
    id: 'male_body_back',
    name: 'Male body back',
    isShow: false,
    icon: '/build/images/male-body-back-min.svg',
    style: 'height: 40px; width: 40px',
    bodyParts: [
      {
        id: 'inner_thigh',
        name: 'Inner thigh',
        location: 'left: 50%; top: 60%',
      },
      {
        id: 'outer_thigh',
        name: 'Outer thigh',
        location: 'left: 30%; top: 60%',
      },
      {
        id: 'arms',
        name: 'Arms',
        location: 'left: 80%; top: 36%',
      },
      {
        id: 'waist',
        name: 'Waist',
        location: 'left: 32.5%; top: 40%',
      },
      {
        id: 'upper_back',
        name: 'Upper back',
        location: 'left: 50%; top: 25%',
      },
      {
        id: 'lower_back',
        name: 'Lower back',
        location: 'left: 50%; top: 40%',
      },
      {
        id: 'buttock',
        name: 'Buttock',
        location: 'left: 60%; top: 51%',
      },
      {
        id: 'calf',
        name: 'Calf',
        location: 'left: 58.5%; top: 80%',
      },
      {
        id: 'ankles_feet',
        name: 'Ankles feet',
        location: 'left: 50%; top: 92.5%',
      },
    ],
  },
  {
    id: 'female_body_back',
    name: 'Female body back',
    isShow: false,
    icon: '/build/images/female-body-back-min.svg',
    style: 'height: 40px; width: 40px',
    bodyParts: [
      {
        id: 'inner_thigh',
        name: 'Inner thigh',
        location: 'left: 50%; top: 60%',
      },
      {
        id: 'outer_thigh',
        name: 'Outer thigh',
        location: 'left: 30%; top: 60%',
      },
      {
        id: 'arms',
        name: 'Arms',
        location: 'left: 80%; top: 36%',
      },
      {
        id: 'waist',
        name: 'Waist',
        location: 'left: 34%; top: 37.5%',
      },
      {
        id: 'upper_back',
        name: 'Upper back',
        location: 'left: 50%; top: 25%',
      },
      {
        id: 'lower_back',
        name: 'Lower back',
        location: 'left: 50%; top: 42.5%',
      },
      {
        id: 'buttock',
        name: 'Buttock',
        location: 'left: 63%; top: 50%',
      },
      {
        id: 'calf',
        name: 'Calf',
        location: 'left: 58.5%; top: 80%',
      },
      {
        id: 'ankles_feet',
        name: 'Ankles feet',
        location: 'left: 50%; top: 95%',
      },
    ],
  },
];
